import React from 'react'

const SolutionContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    var content = containerObject;

var solutionItem = containerObject.SolutionContainer

    return (
        // <!-- Service Start -->
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
            <section class="cyber-features pt-60 bg-light">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8 col-lg-6">
                            <div class="section-heading text-center mb-5">
                                <h5 class="h6 text-primary" dangerouslySetInnerHTML={{ __html: content.containerTitle }}></h5>
                                <h2 dangerouslySetInnerHTML={{ __html: content.containerSubTitle }}></h2>
                                <p class="benefit-content" dangerouslySetInnerHTML={{ __html: content.containerBody }}>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                       
                       {solutionItem ? solutionItem.map((item)=>{
                       
                       return(
                           <>
                       <div class="col-lg-4">
                            <div class="cyber-single-service bg-white rounded-custom mb-30">
                                <div class="align-items-center">
                                    <img src={`${item.mainImage ? item.mainImage : ""}`} alt="partner_benifits" class="img-fluid prominent-icon" height="150px" />
                                </div>
                                <div class="cyber feature-info-wrap">
                                    <h3 class="h5">{item.attributes.header}</h3>
                                    <p class="benefit-content">
                                        {item.attributes.body}
                                    </p>
                                </div>
                            </div>
                        </div>
                        </>
                        )
                    })
                    :"" } 
                        
                    </div>
                </div>
            </section>
        </div>
        /* <!-- Service End --> */
    )
}
export default SolutionContainer